import * as THREE from 'three';
import Win from '../core/Win';
import Cursor from './Cursor';
import win from '../core/Win';
import Tween from "../core/Tween";
import Point from "./point";
import {GUI} from 'dat.gui';
import {Pane} from 'tweakpane';
import Stats from 'three/examples/jsm/libs/stats.module.js'

export const vertexShader = require('../shader/vertexShader.glsl');
export const fragmentShader = require('../shader/fragmentShader.glsl');
const width = 10;
export default class Canvas_tex {
    private _w: number;
    private _h: number;
    public renderer: THREE.WebGLRenderer;
    private container: HTMLElement;
    private _geometry: THREE.IcosahedronGeometry;
    private _material: THREE.ShaderMaterial;
    private _mesh: THREE.Mesh;
    private camera: THREE.PerspectiveCamera;
    private cameraY: number;
    private fovRad: number;
    private dist: number;
    private time: number;
    private lastInnerHeight: number;
    private scene: THREE.Scene;
    private light: THREE.PointLight;
    private _noImg: boolean;
    private _query: string;
    private cursor: Cursor;
    private _pos: any[] = [];
    private _pointProgress: any[] = [];
    private _degree: any[] = [];
    private renderTarget: THREE.WebGLRenderTarget;
    private vector = new THREE.Vector2();
    private _cPower: number = 0;
    private _cellLen: number = 10;
    private _size = Math.pow(width, 2);
    private _data = new Uint8Array(4 * this._size);
    private _stats = new Stats();
    private _movingTimer = 0;
    private _movingIndex = 0;
    private pane = new Pane();
    private _detailNum = 1;

    constructor() {
        this.container = document.getElementById('container') as HTMLElement;
        this._stats.showPanel(0);
        document.body.appendChild(this._stats.dom);
        this.cursor = new Cursor();
        this._query = window.location.search.slice(1);
        this._noImg = this._query === 'noimg';
        this._w = this.container.clientWidth;
        if (Win.isPc) {
            this._h = window.innerHeight;
            this.lastInnerHeight = window.innerHeight;
        } else {
            this._h = window.screen.availHeight;
            this.lastInnerHeight = window.innerHeight;
        }
        this.renderer = new THREE.WebGLRenderer();
        this.renderer.setSize(this._w, this._h);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setClearColor(0x000000, 0);
        this.container.appendChild(this.renderer.domElement);
        const fov = 60;
        this.fovRad = (fov / 2) * (Math.PI / 180);
        this.dist = this._h / 2 / Math.tan(this.fovRad);
        if (Win.isPc) {
            this.cameraY = 0;
        } else {
            this.cameraY = this.lastInnerHeight - this._h;
        }

        this.camera = new THREE.PerspectiveCamera(
            fov,
            this._w / this._h,
            1,
            this.dist * 2,
        );
        this.camera.position.z = this.dist;
        this.camera.position.y = this.cameraY;

        this.time = 0;
        this.scene = new THREE.Scene();

        this.light = new THREE.PointLight(0x00ffff);
        this.light.position.set(2, 2, 2);
        this.scene.add(this.light);

        this._geometry = new THREE.PlaneGeometry(this._w, this._h, 2);
        this._material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
        this._mesh = new THREE.Mesh(this._geometry, this._material);
        this.scene.add(this._mesh);
        this._w = this.container.clientWidth;
        this._h = Win.isPc ? window.innerHeight : window.screen.availHeight;
        // this._material.uniforms.uResolution.value = [this._w, this._h];
        // this._material.uniforms.uRatio.value = [this._w / Math.min(this._w, this._h), this._h / Math.min(this._w, this._h)];
        // window.addEventListener('mousemove', () => {
        //     this._material.uniforms.uMouse.value = this.cursor.getNormalizedPosition();
        // });
        // window.addEventListener('touchmove', () => {
        //     this._material.uniforms.uMouse.value = this.cursor.getNormalizedPosition();
        // });
        const PARAMS = {
            noise: 0.5,
            division: 0,
            count: 0,
            progress: 0,
        };

        // this.pane.addBinding(PARAMS, 'noise', {
        //     step: 0.1,
        // }).on('change', (ev) => {
        //     this._material.uniforms.uNoise.value = ev.value;
        // });
        // this.pane.addBinding(PARAMS, 'division', {
        //     step: 0.1,
        // }).on('change', (ev) => {
        //     this._material.uniforms.uDivision.value = ev.value;
        // });
        // this.pane.addBinding(PARAMS, 'progress', {
        //     step: .1,
        //     min: 0,
        //     max: 4,
        // }).on('change', (ev) => {
        //     // this._detailNum = ev.value;
        //     // this._updateGeo();
        //     this._material.uniforms.uMorph.value = ev.value;
        // });
    }

    getScene() {
        return this.scene;
    }

    resized(): void {
        this._w = this.container.clientWidth;
        this._h = Win.isPc ? window.innerHeight : window.screen.availHeight;
        this.renderer.setSize(this._w, this._h);
        this.camera.aspect = this._w / this._h;
        this.dist = (this._h / 2 / Math.tan(this.fovRad));
        this._geometry = new THREE.PlaneGeometry(this._w/2, this._h/2, 2);
        if (this._mesh) {
            this._mesh.geometry.dispose(); // 古いジオメトリを破棄
            this._mesh.geometry = this._geometry; // 新しいジオメトリを設定
        }

        this.camera.position.z = this.dist;
        this.camera.updateProjectionMatrix();
    }

    updated(): void {
        //fps表示
        this._stats.begin();
        this._stats.end();
        this.cursor.startTimer();
        this._movingTimer = this.cursor.getMovingTime();
        this._movingIndex = Math.floor(this._movingTimer / (250)) % (this._cellLen + 1);
        this.time += 0.01;
        this.renderTarget = new THREE.WebGLRenderTarget(this._w / 2, this._h / 2);
        this.renderer.setRenderTarget(this.renderTarget);
        this.renderer.render(this.scene, this.camera);
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.scene, this.camera);
        this.vector = this.cursor.getVector();
        this._cPower = Math.abs(Math.sqrt(this.vector.x * this.vector.x + this.vector.y * this.vector.y) - 1) * 100;

    }
}
